/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';
import PropTypes from 'prop-types';

import * as Ui from './SizePicker.styles';

export const SizePicker = ({ onClick, sizes, defaultActive, selectedSizesUids }) => {
  const arrow = (direction) => (
    <Ui.ArrowWrapper>
      {direction === 'left' ? (
        <MdArrowBack size="16px" color="#ffffff" />
      ) : (
        <MdArrowForward size="16px" color="#ffffff" />
      )}
    </Ui.ArrowWrapper>
  );

  if (!selectedSizesUids?.length) return null;

  return (
    <Ui.Wrapper
      withArrows={sizes.length > 2}
      autoScroll
      defaultActive={sizes.indexOf((s) => s.uid === defaultActive)}
      customArrows={{ left: arrow('left'), right: arrow('right') }}
    >
      {sizes.map((size, index) => (
        <Ui.Size
          selected={selectedSizesUids.includes(size.uid)}
          onClick={onClick ? () => onClick(size.uid) : undefined}
          key={size.name}
          data-index={index}
        >
          <p>{size.name.toUpperCase()}</p>
        </Ui.Size>
      ))}
    </Ui.Wrapper>
  );
};

SizePicker.propTypes = {
  sizes: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  selectedSizesUids: PropTypes.arrayOf(PropTypes.string),
  defaultActive: PropTypes.string,
  onClick: PropTypes.func,
};
